import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ShopContextProvider, ShopContext } from "./context/ShopContext";
import { CookieConsentProvider } from "./context/CookieConsentContext";
import { HelmetProvider } from "react-helmet-async";
import { ReactLenis } from "lenis/react";

const root = document.getElementById("root");

const render = () => {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <ShopContextProvider>
        <HelmetProvider>
          <CookieConsentProvider>
            <ReactLenis
              root
              options={{
                smooth: true,
                duration: 0.9,
                easing: (t) => 1 - Math.pow(1 - t, 3),
                lerp: 0.1,
                wheelEvents: true,
                touchEvents: true,
                inertia: 0.9,
                overflow: "hidden",
                direction: "vertical",
              }}
            >
              <App />
            </ReactLenis>
          </CookieConsentProvider>
        </HelmetProvider>
      </ShopContextProvider>
    </React.StrictMode>,
  );
};

render();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
